// extracted by mini-css-extract-plugin
export default {"createTemplateModal":"CreateTemplateModal_createTemplateModal__x82iI","content":"CreateTemplateModal_content__vvbNr"};